import { AppStateType } from '../reducers'
import { IDatafile } from '../types/datafile'

export const selectDataFile = ({ datafile }: AppStateType): IDatafile =>
  datafile
